import { render, staticRenderFns } from "./ProductDisplayStatusPopupIframe.vue?vue&type=template&id=6351e61a&"
import script from "./ProductDisplayStatusPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductDisplayStatusPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports